var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"datePickerEl",staticClass:"date-picker",style:('color:' + _vm.textColor),attrs:{"type":"date","disabled":false},on:{"change":_vm.emitChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }